import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { GenderButton } from 'page/catalog/StandGenders/GenderButton'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './StandGenders.module.scss'

export const StandGenders = observer(() => {
  const demo = useDemo()
  const { options } = demo

  return <Space className={css.pane} gap={4} pad={8} wide columns>
    <GenderButton gender="" />
    {options.genders?.map(gender => <GenderButton key={gender} gender={gender} />)}
  </Space>
})
